import { SpriteItem } from './types'

export const spriteData: SpriteItem[] = [
  { class: 'ships', x: 10, y: 10, w: 1920, h: 893, speed: 0.2, top: 0, left: 0, dx: 0, dy: 0 },
  {
    class: 'сord-left',
    x: 1745,
    y: 1662,
    w: 839,
    h: 698,
    speed: 0.5,
    top: 125,
    left: 90,
    dx: -50,
    dy: -40,
  },
  {
    class: 'wave',
    effect: 'scale',
    x: 10,
    y: 923,
    w: 1199,
    h: 719,
    speed: 1,
    axis: 'x',
    top: 25,
    left: 355,
    dx: 0,
    dy: 0,
  },
  {
    class: 'hook',
    x: 2890,
    y: 863,
    w: 662,
    h: 663,
    speed: 1.8,
    top: 225,
    left: 1080,
    dx: 30,
    dy: 120,
  },
  {
    class: 'bg-dummy',
    x: 3047,
    y: 2263,
    w: 100,
    h: 105,
    speed: 1,
    top: 600,
    left: 295,
    dx: -20,
    dy: 10,
  },
  {
    class: 'stone-left-bottom',
    x: 2784,
    y: 950,
    w: 73,
    h: 96,
    speed: 1.6,
    top: 515,
    left: 250,
    dx: -160,
    dy: 140,
  },
  {
    class: 'box-left',
    x: 2890,
    y: 1963,
    w: 312,
    h: 280,
    speed: 1.2,
    axis: 'y',
    top: 435,
    left: 135,
    dx: -50,
    dy: 50,
  },
  {
    class: 'box-center',
    x: 2225,
    y: 950,
    w: 213,
    h: 190,
    speed: 1,
    top: 405,
    left: 515,
    dx: -100,
    dy: 50,
  },
  {
    class: 'box-right',
    x: 1950,
    y: 950,
    w: 255,
    h: 228,
    speed: 2,
    top: 380,
    left: 1360,
    dx: 150,
    dy: -20,
  },
  {
    class: 'stone-bottom',
    x: 3399,
    y: 1546,
    w: 138,
    h: 146,
    speed: 3,
    axis: 'xy',
    top: 650,
    left: 500,
    dx: -15,
    dy: 100,
  },
  {
    class: 'stone-right-bottom',
    x: 2890,
    y: 2263,
    w: 137,
    h: 105,
    speed: 2,
    top: 535,
    left: 1630,
    dx: 125,
    dy: 15,
  },
  {
    class: 'stone-right-center',
    x: 3047,
    y: 2263,
    w: 105,
    h: 70,
    speed: 3,
    top: 430,
    left: 1745,
    dx: 160,
    dy: 0,
  },
  {
    class: 'stone-left-top',
    x: 3399,
    y: 1845,
    w: 114,
    h: 86,
    speed: 7,
    top: 340,
    left: 75,
    dx: -70,
    dy: 10,
  },
  {
    class: 'stone-left-covered',
    x: 1950,
    y: 1198,
    w: 74,
    h: 89,
    speed: 3,
    top: 560,
    left: 305,
    dx: -15,
    dy: 100,
  },
  {
    class: 'stone-right-top',
    x: 3399,
    y: 1712,
    w: 157,
    h: 113,
    speed: 3,
    top: 270,
    left: 1730,
    dx: 60,
    dy: -80,
  },
  {
    class: 'fish-left',
    x: 2458,
    y: 950,
    w: 165,
    h: 146,
    speed: 1.2,
    top: 160,
    left: 138,
    dx: -90,
    dy: 0,
  },
  {
    class: 'fish-center',
    x: 3222,
    y: 1963,
    w: 293,
    h: 235,
    speed: 2,
    axis: 'x',
    top: 275,
    left: 330,
    dx: 0,
    dy: 0,
  },
  {
    class: 'fish-right',
    x: 2890,
    y: 1546,
    w: 489,
    h: 397,
    speed: 1.3,
    top: 40,
    left: 1315,
    dx: 70,
    dy: -10,
  },
]
